<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-col lg="12" v-else>
            <data-table
                ref="tablaHorario"
                :tableName="'Horarios'"
                :url="url"
                :columns="columns"
                :filters="filters"
                @loadModalData="loadModalData"
                @setFilters="setFilters"
                :showAdvancedFilters="true"
                :perPage="[10, 25, 50, 100]"
            >
                <template slot="actionButtonsLeft">
                    <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                        <v-btn
                            rounded
                            color="#004BAF"
                            class="btnAdd"
                            right
                            @click="abrirModal('add')"
                        >
                            <v-icon dark class="mr-2">add</v-icon>Agregar
                            <div class="mr-4"></div>
                        </v-btn>
                    </div>
                </template>

                <!--Busqueda avanzada-->
                <template slot="filters">
                    <v-col xs="12" sm="6" md="6" class="py-0">
                       <v-text-field
                       outlined
                       label="Nombre"
                       v-model="advancedSearch.nombre">
                       </v-text-field> 
                    </v-col>
                    <v-col xs="12" sm="6" md="6" class="py-0">
                        <v-autocomplete
                        outlined
                        :items="jornadas"
                        item-text="descripcion"
                        item-value="id"
                        label="Tipo jornada"
                        persistent-hint
                        v-model="advancedSearch.jornada_id"
                        no-data-text="Datos no disponibles">
                        </v-autocomplete>
                        
                    </v-col>
                    <v-col v-if="rol == 'root'" xs="12" sm="6" md="12" class="py-0">
                        <v-autocomplete
                        outlined
                        :items="clientes"
                        item-text="nombre"
                        item-value="id"
                        label="Cliente"
                        persistent-hint
                        v-model="cliente_value"
                        no-data-text="Datos no disponibles"></v-autocomplete>
                    </v-col>
                    <v-col v-if="rol == 'root' || rol == 'admin'"  xs="12" sm="6" md="6" class="py-0">
                        <v-autocomplete
                        outlined
                        :items="empresas"
                        item-text="nombre"
                        item-value="id"
                        label="Empresa"
                        persistent-hint
                        v-model="empresa_value"
                        no-data-text="Datos no disponibles"></v-autocomplete>
                    </v-col>
                    <v-col v-if="rol == 'root' || rol == 'admin' || rol =='admin-empresa'" xs="12" sm="6" md="6" class="py-0">
                        <v-autocomplete
                        outlined
                        :items="sucursales"
                        item-text="nombre"
                        item-value="id"
                        label="Sucursal"
                        persistent-hint
                        v-model="sucursal_value"
                        no-data-text="Datos no disponibles"></v-autocomplete>
                    </v-col>
                </template>

                <tbody slot="body" slot-scope="{ data }">
                    <tr :key="item.id" v-for="item in data">
                        <td v-if="rol == 'root'">
                            <div class="tblPrincipal">{{ item.nombre_empresa }}</div>
                        </td>

                        <td v-if="rol == 'admin'">
                            <div class="tblPrincipal">{{ item.nombre_empresa }}</div>
                        </td>
                        <td v-if="rol == 'admin'">
                            <div class="tblPrincipal">{{ item.nombre_sucursal }}</div>
                        </td>

                        <td v-if="rol == 'admin-empresa'">
                            <div class="tblPrincipal">{{ item.nombre_sucursal }}</div>
                        </td>

                        <td v-if="rol == 'admin-sucursal'">
                            <div class="tblPrincipal">{{ item.nombre }}</div>
                        </td>

                        <td v-if="rol != 'admin-sucursal'">
                            <div class="tblPrincipal">{{ item.nombre }}</div>
                        </td>
                        <td>
                            <div class="tblPrincipal">{{ item.descripcion }}</div>
                        </td>

                        <td v-if="rol == 'admin-depto'">
                            <div class="tblPrincipal">{{ item.minutos_tolerancia }}</div>
                        </td>

                        <td v-if="rol != 'admin-depto' && rol != 'empleado'" >
                            <div class="tblOpciones">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            class="botonHover"
                                            icon
                                            fab
                                            dark
                                            small
                                            @click="abrirModal('update', item)"
                                        >
                                            <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="permisos.delete">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            class="botonHover"
                                            icon
                                            fab
                                            dark
                                            small
                                            @click="eliminar(item.id, item.nombre)"
                                        >
                                            <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </data-table>
        </v-col>

        <template>
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imagen" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8" class="py-0">
                                        <v-text-field
                                            autofocus
                                            id="primero"
                                            outlined
                                            label="Nombre"
                                            v-model="horario.nombre"
                                            v-validate="'required'"
                                            data-vv-name="Nombre"
                                            :error-messages="errors.collect('Nombre')"
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Minutos tolerancia"
                                            v-model="horario.minutos_tolerancia"
                                            type="number"
                                            v-validate="'required|numeros_positivos'"
                                            data-vv-name="Minutos tolerancia"
                                            :error-messages="errors.collect('Minutos tolerancia')"
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Descripción"
                                            v-model="horario.descripcion"
                                            v-validate="'required'"
                                            data-vv-name="descripcion"
                                            :error-messages="errors.collect('descripcion')"
                                        />
                                    </v-col>
                                    <template>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="jornadas"
                                                item-text="descripcion"
                                                item-value="id"
                                                label="Tipo jornada"
                                                persistent-hint
                                                v-model="horario.jornada_id"
                                                v-validate="'required'"
                                                data-vv-name="Tipo Jornada"
                                                :error-messages="errors.collect('Tipo Jornada')"
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'root'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Cliente"
                                                persistent-hint
                                                v-model="cliente_value"
                                                v-validate="'required'"
                                                data-vv-name="Cliente"
                                                :error-messages="errors.collect('Cliente')"
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Empresa"
                                                persistent-hint
                                                v-model="empresa_value"
                                                v-validate="'required'"
                                                data-vv-name="Empresa"
                                                :error-messages="errors.collect('Empresa')"
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Sucursal"
                                                persistent-hint
                                                v-model="horario.sucursal_id"
                                                v-validate="'required'"
                                                data-vv-name="Sucursal"
                                                :error-messages="errors.collect('Sucursal')"
                                                required
                                            />
                                        </v-col>
                                    </template>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0 pl-3">
                                                <h4 class="selDias">Seleccionar días</h4>
                                            </v-col>
                                            
                                            <div class="centrar">
                                                <v-checkbox
                                                    v-for="(d, index) in semanaHorarios"
                                                    :key="index"
                                                    hide-details
                                                    class="shrink mr-4 mt-0 dias"
                                                    v-model="dias_seleccionados"
                                                    :label="d.dia"
                                                    :value="d.dia"
                                                    :disabled="d.desabilitar"
                                                ></v-checkbox>
                                            </div>
                                </v-row>
                                <v-row>
                                    <v-col v-if="!navegador" cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Hora entrada"
                                            v-model="hora_entrada"
                                            id="hora_entrada"
                                            type="time"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-else cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu1"
                                            :close-on-content-click="false"
                                            :nudge-right="10"
                                            :return-value.sync="hora_entrada"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="hora_entrada"
                                                    label="Hora entrada"
                                                    readonly
                                                    outlined
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu1"
                                                v-model="hora_entrada"
                                                full-widthformat="24hr"
                                                scrollable
                                                ampm-in-title
                                                @click:minute="$refs.menu.save(hora_entrada)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col v-if="!navegador" cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Hora salida"
                                            v-model="hora_salida"
                                            id="hora_salida"
                                            type="time"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-else cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                                        <v-menu
                                            ref="menuFin"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="hora_salida"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="hora_salida"
                                                    label="Hora salida"
                                                    readonly
                                                    outlined
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu2"
                                                v-model="hora_salida"
                                                full-widthformat="24hr"
                                                scrollable
                                                ampm-in-title
                                                @click:minute="$refs.menuFin.save(hora_salida)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2" class="py-0">
                                        <v-btn
                                            color="#1E2245"
                                            elevation="0"
                                            class="mt-2"
                                            dark
                                            fab
                                            @click="agregarHorario()"
                                            small
                                        >
                                            <v-icon dark>add</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="pa-0 ma-0">
                                    <v-col col="12" xs="12" sm="3" md="4" lg="4" xl="4" class="pt-0">
                                        <v-input disabled class="pl-2">Día</v-input>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="pt-0">
                                        <v-input disabled class="pl-2">Entrada</v-input>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3"  class="pt-0">
                                        <v-input disabled class="pl-2">Salida</v-input>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <template v-for="(i, index) in horario.detalles_horario">
                                        <v-col col="12" xs="12" sm="3" md="4" lg="4" xl="4"  :key="index" class="detalle">
                                            <v-text-field
                                                label="Dia"
                                                disabled
                                                class
                                                type="text"
                                                :value="i.dia"
                                                outlined
                                                single-line
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" :key="'A'+index" class="detalle">
                                            <v-text-field
                                                label="entrada"
                                                type="text"
                                                :value="i.hora_entrada"
                                                disabled
                                                outlined
                                                single-line
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" :key="'B'+index" class="detalle">
                                            <v-text-field
                                                label="salida"
                                                type="text"
                                                :value="i.hora_salida"
                                                disabled
                                                outlined
                                                single-line
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2"  :key="'C'+index" class="detalle">
                                            <v-btn
                                                :key="index"
                                                class="botonHover"
                                                icon
                                                fab
                                                dark
                                                small
                                                @click="eliminaHorario2(index, i.id)"
                                            >
                                                <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar pull-right"
                                @click="cerrarModal()"
                                :disabled="loading_guardar"
                            >
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar pull-right"
                                @click="guardar()"
                                :loading="loading_guardar"
                                v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                            >
                                Guardar
                            </v-btn>
                        </v-card-actions>
                        <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                            <v-alert
                                dense
                                outlined
                                type="error"
                                
                            >
                                El usuario no tiene permiso para editar el registro.
                            </v-alert>
                        </div>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Notify from "@/plugins/notify";
import Datatable from "@/components/datatable/Datatable.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import horariosApi from "../api/horarios";
import clientesApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import apiTipoJornada from "../api/tipoJornada";

export default {
    name: "Horario",
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "horarios/find",
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                nombre          : null,
                jornada_id      : null,
                departamento_id : null,
                order_by        : 'nombre',
            },
            columns: [
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ],
            advancedSearch: {
                nombre: null,
                jornada_id: null
            },
            loading_guardar : false,
            loading         : true,
            dialog          : false,
            search          : "",
            datosLogin      : "",
            complex     : {
                selected: [],
                headers: [
                    { text: "Nombre", value: "nombre" },
                    { text: "Descripción", value: "descripcion" },
                    { text: "Opciones", value: "" },
                ],
                items: [],
            },
            horario: {
                id          : 0,
                nombre      : "",
                descripcion : "",
                minutos_tolerancia: "",
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                detalles_horario: [],
                detalles_eliminados: [],
                jornada_id  : null,
            },
            dias_seleccionados: [],
            semanaHorarios: [
                { dia: "Lunes", desabilitar: false },
                { dia: "Martes", desabilitar: false },
                { dia: "Miércoles", desabilitar: false },
                { dia: "Jueves", desabilitar: false },
                { dia: "Viernes", desabilitar: false },
                { dia: "Sábado", desabilitar: false },
                { dia: "Domingo", desabilitar: false },
            ],
            semana: [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ],
            semanaOriginal: [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ],
            dia             : "",
            hora_entrada    : "",
            hora_salida     : "",
            datosLogin      : "",
            titulo_modal    : "",
            finaliza_carga  : false,
            parametros_base: { activo: true, paginate: false },
            action          : "",
            clientes        : [],
            empresas        : [],
            sucursales      : [],
            departamentos   : [],
            cliente_value   : null,
            empresa_value   : null,
            sucursal_value  : null,
            rol             : "",
            dias_eliminados : [],
            jornadas        : [],
            imagen          : "",
            navegador       :false,
            menu1           : false,
            menu2           : false,
            jornada_nocturna : false,
            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val!=null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(val!=null){
                this.cambiaEmpresa(val);
            }
        },
        "horario.jornada_id"(value){
            for(let jornada of this.jornadas){
                if(jornada.id == value){
                    if(jornada.clave === "02"){
                        this.jornada_nocturna = true;
                    }else{
                        this.jornada_nocturna = false;
                    }
                }
            }
        }
    },
    methods: {
        eliminar(id, horario) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el horario?",
                "Eliminar",
                () => {
                    horariosApi.deleteHorario(id).then((response) => {
                        this.$refs.tablaHorario.getData();
                        this.respuesta_ok("El horario ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },
        async listar() {
            //await this.resetValue();
            this.loading = true;
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            let departamento_id = null;
            this.complex.headers = [
                { text: "Nombre", value: "nombre" },
                { text: "Descripción", value: "descripcion" },
                { text: "Opciones", value: "" },
            ];

            if (this.rol == "root") {
            }
            if (this.rol == "admin") {
                this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
                this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
                this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
                this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
                this.horario.departamento_id = this.filters.departamento_id = this.datosLogin.departamento_id;
            }
        },
        async loadModalData() {
            await this.resetValue();
            let cliente = null;
            let empresa = null;
            let sucursal = null;
            let depto = null;

            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                //this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                
                //this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                empresa = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-suscursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.datosLogin.sucursal_id;
                this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                sucursal = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.datosLogin.sucursal_id;
                depto = this.datosLogin.departamento_id;

            }

           

            this.getTipoJornada()
        },
        setFilters() {
            let nombre = this.advancedSearch.nombre;
            let cliente = this.cliente_value;
            let empresa = this.empresa_value;
            let sucursal = this.sucursal_value;
            let jornada = this.advancedSearch.jornada_id
            let cliente_id;
            let empresa_id;
            let sucursal_id;
            let departamento_id;

            if (this.rol == "admin") {
                cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                sucursal_id = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                departamento_id = this.datosLogin.departamento_id;
            }

            let filterParams = {
                nombre: nombre,
                cliente_id: cliente,
                empresa_id: empresa,
                sucursal_id: sucursal,
                jornada_id: jornada
            };


            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.horario.sucursal_id = null;
        },
        async abrirModal(accion, item = null) {
            await this.resetValue();
            let self = this;
            this.errors.clear();
            this.accion = accion;
            this.finaliza_carga = false;
            this.detectarNavegador();
            this.getClientes();
            this.getTipoJornada();
            $("#primero").focus();
            if (accion == "add") {
                this.titulo_modal = "Registro de horario";
                this.imagen = "/static/modal/horarioCreate.svg";
                let ordenaDetalle_horario = [];
                for (var i = 0; i < self.semanaOriginal.length; i++) {
                    for (var j = 0; j < self.horario.detalles_horario.length; j++) {
                        if (self.semanaOriginal[i] === self.horario.detalles_horario[j].dia) {
                            ordenaDetalle_horario.push(self.horario.detalles_horario[j]);
                        }
                    }
                }
                self.horario.detalles_horario = ordenaDetalle_horario;
                self.horario.detalles_horario.forEach((element) => {
                    self.semanaHorarios.forEach((el) => {
                        if (element.dia == el.dia) {
                            el.desabilitar = true;
                        }
                    });
                });
                self.horario.detalles_horario.forEach(function(element) {
                if (element.dia === "Lunes") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Martes") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Miércoles") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Jueves") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Viernes") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Sábado") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                if (element.dia === "Domingo") {
                    let index = self.semana.indexOf(element.dia);
                    self.semana.splice(index, 1);
                }
                });

                this.finaliza_carga = true;
            } else {
                this.titulo_modal = "Actualizar horario";
                this.imagen = "/static/modal/horarioUpdate.svg";

                horariosApi.getHorario(item.id).then((response) => {
                    self.horario.id = response.id;
                    self.horario.nombre = response.nombre;
                    self.horario.descripcion = response.descripcion;
                    self.horario.minutos_tolerancia = response.minutos_tolerancia;
                    self.cliente_value = response.cliente_id;
                    self.empresa_value = response.empresa_id;
                    self.horario.sucursal_id = response.sucursal_id;
                    self.horario.detalles_horario = response.detalles_horarios;
                    self.horario.jornada_id = response.jornada_id;
                    if (response.cliente != undefined) {
                        self.horario.cliente_id = response.cliente_id;
                    }
                    if (response.empresa != undefined) {
                        self.horario.empresa_id = response.empresa_id;
                    }
                    if (response.sucursal != undefined) {
                        self.horario.sucursal_id = response.sucursal_id;
                    }

                    let ordenaDetalle_horario = [];
                    for (var i = 0; i < self.semanaOriginal.length; i++) {
                        for (var j = 0; j < self.horario.detalles_horario.length; j++) {
                            if (self.semanaOriginal[i] === self.horario.detalles_horario[j].dia) {
                                ordenaDetalle_horario.push(self.horario.detalles_horario[j]);
                            }
                        }
                    }
                    self.horario.detalles_horario = ordenaDetalle_horario;
                    self.horario.detalles_horario.forEach((element) => {
                        self.semanaHorarios.forEach((el) => {
                            if (element.dia == el.dia) {
                                el.desabilitar = true;
                            }
                        });
                    });
                    self.horario.detalles_horario.forEach(function(element) {
                        if (element.dia === "Lunes") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Martes") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Miércoles") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Jueves") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Viernes") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Sábado") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                        if (element.dia === "Domingo") {
                            let index = self.semana.indexOf(element.dia);
                            self.semana.splice(index, 1);
                        }
                    });
                    this.finaliza_carga = true;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading_guardar = false;
                    Notify.ErrorToast("Ocurrió un error al cargar los horarios.");
                });
            }
            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
            }
            if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.horario.sucursal_id = this.datosLogin.sucursal_id;
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        agregarHorario() {
            let self = this;
            if (
                this.dias_seleccionados != "" &&
                this.hora_entrada != "" &&
                this.hora_salida != ""
            ) {
                var hr_entrada = parseInt(this.hora_entrada.substring(0, 2));
                var min_entrada = parseInt(this.hora_entrada.substring(2, 4));
                var hr_salida = parseInt(this.hora_salida.substring(0, 2));
                var min_salida = parseInt(this.hora_salida.substring(2, 4));
                if (
                    hr_entrada > 23 ||
                    min_entrada > 60 ||
                    hr_salida > 23 ||
                    min_salida > 60
                ) {
                    Notify.Warning("Hora incorrecta", "La hora registrada es incorrecta" );
                } else {
                    if (!this.jornada_nocturna && (this.hora_salida <= this.hora_entrada)) {
                        Notify.Warning("Hora incorrecta", "La hora de salida debe ser mayor a la hora de entrada. Formato de hora hh:mm, Ejemplos: 09:00 - 13:00" );
                    } else {
                        if (this.hora_entrada.length < 4 || this.hora_salida.length < 4) {
                            Notify.Warning("Formato de hora incorrecta", "Formato de hora hh:mm, Ejemplos: 09:00 - 13:00" );
                        } else {
                            this.hora_entrada =
                                this.hora_entrada.substring(0, 2) +
                                ":" +
                                this.hora_entrada.substring(3, 5) +
                                ":00";

                            this.hora_salida =
                                this.hora_salida.substring(0, 2) +
                                ":" +
                                this.hora_salida.substring(3, 5) +
                                ":00";
                            this.dias_seleccionados.forEach((element) => {
                                let detalle_horario = {
                                    id: 0,
                                    dia: element,
                                    hora_entrada: this.hora_entrada,
                                    hora_salida: this.hora_salida,
                                }; //Se agrega el id:0
                                this.horario.detalles_horario.push(detalle_horario);
                                let ordenaDetalle_horario = [];
                                for (var i = 0; i < this.semanaOriginal.length; i++) {
                                    for (
                                        var j = 0;
                                        j < this.horario.detalles_horario.length;
                                        j++
                                    ) {
                                        if (this.semanaOriginal[i] === this.horario.detalles_horario[j].dia) {
                                            ordenaDetalle_horario.push(
                                                this.horario.detalles_horario[j]
                                            );
                                        }
                                    }
                                }
                                this.horario.detalles_horario = ordenaDetalle_horario;
                            });
                            this.horario.detalles_horario.forEach((element) => {
                                this.semanaHorarios.forEach((el) => {
                                    if (element.dia == el.dia) {
                                        el.desabilitar = true;
                                    }
                                });
                            });
                            this.dias_seleccionados = [];
                            this.hora_entrada = "";
                            this.hora_salida = "";
                        }
                    }
                }
            }
            else{
                if(this.dias_seleccionados.length == 0){
                    Notify.Warning("Seleccionar días", "Seleccionar al menos un día." );
                }
                else if( this.hora_entrada == "" || this.hora_salida == ""){
                    Notify.Warning("Formato hora", "Ingresar un horario correcto. Ejemplo: 12:30." );
                }                
            }
        },
        agregarDia(para_p) {
            if (this.dia != "" && this.hora_entrada != "" && this.hora_salida != "") {
                var hr_entrada = parseInt(this.hora_entrada.substring(0, 2));
                var min_entrada = parseInt(this.hora_entrada.substring(2, 4));
                var seg_entrada = parseInt(this.hora_entrada.substring(4, 6));
                var hr_salida = parseInt(this.hora_salida.substring(0, 2));
                var min_salida = parseInt(this.hora_salida.substring(2, 4));
                var seg_salida = parseInt(this.hora_salida.substring(4, 6));
                if (
                    hr_entrada > 23 ||
                    min_entrada > 60 ||
                    seg_entrada > 60 ||
                    hr_salida > 23 ||
                    min_salida > 60 ||
                    seg_salida > 60
                ) {
                    Swal.fire({
                        type: "info",
                        title: "Hora erronea",
                        text: "La hora registrada es incorrecta",
                    });
                } else {
                    this.hora_entrada =
                        this.hora_entrada.substring(0, 2) +
                        +this.hora_entrada.substring(2, 4) +
                        ":" +
                        this.hora_entrada.substring(4, 6);
                    this.hora_salida =
                        this.hora_salida.substring(0, 2) +
                        ":" +
                        this.hora_salida.substring(2, 4) +
                        ":" +
                        this.hora_salida.substring(4, 6);
                    let detalle_horario = {
                        id: 0,
                        dia: this.dia,
                        hora_entrada: this.hora_entrada,
                        hora_salida: this.hora_salida,
                    }; //Se agrega el id:0
                    this.horario.detalles_horario.push(detalle_horario);
                    let ordenaDetalle_horario = [];
                    for (var i = 0; i < this.semanaOriginal.length; i++) {
                        for (var j = 0; j < this.horario.detalles_horario.length; j++) {
                            if (this.semanaOriginal[i] === this.horario.detalles_horario[j].dia) {
                                ordenaDetalle_horario.push(this.horario.detalles_horario[j]);
                            }
                        }
                    }
                    this.horario.detalles_horario = ordenaDetalle_horario;
                    let index = this.semana.indexOf(this.dia);
                    this.semana.splice(index, 1);
                    this.dia = "";
                    this.hora_entrada = "";
                    this.hora_salida = "";
                }
            }
        },
        eliminaHorario(index, id) {
            if (id != 0) {
                let id_dia = { id: id };
                this.horario.detalles_eliminados.push(id_dia);
            }
            let dia = this.horario.detalles_horario[index].dia;
            this.semana.push(dia);
            let ordenaSemana = [];
            for (var i = 0; i < this.semanaOriginal.length; i++) {
                for (var j = 0; j < this.semana.length; j++) {
                    if (this.semanaOriginal[i] === this.semana[j]) {
                        ordenaSemana.push(this.semanaOriginal[i]);
                    }
                }
            }
            this.semana = ordenaSemana;
            this.horario.detalles_horario.splice(index, 1);
        },
        eliminaHorario2(index, id) {
            if (id != 0) {
                let id_dia = { eliminado_id: id };
                this.horario.detalles_eliminados.push(id_dia);
            }
            let dia = this.horario.detalles_horario[index].dia;
            this.semanaHorarios.forEach((el) => {
                if (dia == el.dia) {
                    el.desabilitar = false;
                }
            });
            this.horario.detalles_horario.splice(index, 1);
        },
        guardar() {
            this.horario.cliente_id = this.cliente_value;
            this.horario.empresa_id = this.empresa_value;
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;

                    if(this.horario.detalles_horario.length == 0){
                        Notify.ErrorToast("Es requerido agregar al menos un día con horario");
                        this.loading_guardar = false;
                    }else{
                        this.horario.minutos_tolerancia = parseInt( this.horario.minutos_tolerancia,10);
                        if (this.accion === "add") {
                            horariosApi.addHorario(this.horario).then((response) => {
                                this.$refs.tablaHorario.getData();
                                this.listar();
                                this.respuesta_ok("Horario creado satisfactoriamente.");
                            })
                            .catch((err) => {
                                this.respuesta_error(err);
                            });
                        } else if (this.accion === "update") {
                            horariosApi.updateHorario(this.horario).then((response) => {
                                this.$refs.tablaHorario.getData();
                                this.listar();
                                this.respuesta_ok("Horario actualizado satisfactoriamente.");
                            })
                            .catch((err) => {
                                this.respuesta_error(err);
                            });
                        }
                    }
                }
            });
            this.semana = [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ];
        },
        async getClientes(clientes = null) {
            let param = { activo: true, paginate: false };
            await clientesApi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        async getEmpresas(empresa = null) {
            let param = { activo: true, paginate: false };
            await empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaCliente(cliente, accion = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };
            empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(empresa, accion = null) {
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
       
        getTipoJornada() {
            let parametros = { activo: true, paginate: false, order: "asc" };
            apiTipoJornada.find(parametros).then((response) => {
                this.jornadas = response.data;
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las jornadas.");
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValue();
        },
        async resetValue() {
            this.horario= {
                id          : 0,
                nombre      : "",
                descripcion : "",
                minutos_tolerancia: "",
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                detalles_horario: [],
                detalles_eliminados: [],
                jornada_id  : null,
            };
            this.dia = "";
            this.hora_entrada = "";
            this.hora_salida = "";
            this.semana = [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo",
            ];
            this.semanaHorarios = [
                { dia: "Lunes", desabilitar: false },
                { dia: "Martes", desabilitar: false },
                { dia: "Miércoles", desabilitar: false },
                { dia: "Jueves", desabilitar: false },
                { dia: "Viernes", desabilitar: false },
                { dia: "Sábado", desabilitar: false },
                { dia: "Domingo", desabilitar: false },
            ];
            this.dias_seleccionados = [];
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.clientes = [];
            this.empresas = [];
            this.sucursales = [];
            this.departamentos = [];
            this.loading_guardar = false;
            this.jornadas = [];

            this.advancedSearch = {
                nombre: null,
                jornada_id: null
            }
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj = "") {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        columnasTablas(){
            if (this.rol == "root") {
                this.columns.unshift({
                    label: "Empresa",
                    name: "empresa",
                    filterable: true,
                });
            }
            if (this.rol == "admin") {
                this.columns.unshift(
                    { label: "Empresa", name: "empresa", filterable: true },
                    { label: "Sucursal", name: "sucursal", filterable: true }
                );
            } else if (this.rol == "admin-empresa") {
                this.columns.unshift({
                    label: "Sucursal",
                    name: "sucursal",
                    filterable: true,
                });
            } else if (this.rol == "admin-sucursal") {
            } else if (this.rol == "admin-depto") {
                this.columns.pop();
                this.columns.unshift({
                    label: "Minutos de tolerancia",
                    name: "minutos_tolerancia",
                    filterable: false,
                });
            }
        },
        detectarNavegador(){
            var sBrowser, sUsrAg = navigator.userAgent;
                if(sUsrAg.indexOf("Chrome") > -1) {
                    sBrowser = "Google Chrome";
                    this.navegador = false;
                } else if (sUsrAg.indexOf("Safari") > -1) {
                    sBrowser = "Apple Safari";
                    this.navegador = true;
                } else if (sUsrAg.indexOf("Opera") > -1) {
                    sBrowser = "Opera";
                    this.navegador = false;
                } else if (sUsrAg.indexOf("Firefox") > -1) {
                    sBrowser = "Mozilla Firefox";
                    this.navegador = false;
                } else if (sUsrAg.indexOf("MSIE") > -1) {
                    sBrowser = "Microsoft Internet Explorer";
                    this.navegador = false;
                }
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("horarios.store")
            this.permisos.update = permisosStorage.includes("horarios.update")
            this.permisos.delete = permisosStorage.includes("horarios.delete")
        },
    },
    async created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        this.permisosVista();

        if (this.rol == "root") {
        }
        if (this.rol == "admin") {
            this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
        } else if (this.rol == "admin-empresa") {
            this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
        } else if (this.rol == "admin-sucursal") {
            this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            this.horario.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
        } else if (this.rol == "admin-depto") {
            this.horario.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            this.horario.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            this.horario.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            departamento_id = this.filters.departamento_id = this.datosLogin.departamento_id;
        }
        await this.columnasTablas();
        await this.listar();
    },
};
</script>
<style scoped>
    .centrar {
        height: 90px;
        width: 500px;
        margin: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 25px;
    }
    .dias {
        height: 35px;
    }
    .selDias {
        margin-top: -10px;
        font-family: "Montserrat";
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.2px;
        color: #A0A4A8;
        margin-bottom: 15px;
    }

    .detalle {
        margin-top: -30px !important;
    }
</style>
